module.exports = __webpack_public_path__ + "img/poster_en.3ee9718b.png";